<mat-drawer-container  class="conteiner-desktop">
    <mat-drawer disableClose #drawer [ngClass]="{'sidenav-desktop': !isPhone}" [mode]="isPhone? 'push': 'side'" [opened]="!isPhone">
        <div class="navigation-list" [ngClass]="{'navigation-list-desktop': !isPhone}">

            <div class="logo-container" *ngIf="!isPhone">
                <img
                    *ngIf="logoUrl; else defaultLogo"
                    [src]="logoUrl"
                    alt="Logo da Conta"
                    class="logoUrl"
                />
                <ng-template #defaultLogo>
                    <img
                        src="../../../../assets/images/logo/logo-hudlygo.png"
                        alt="Logo padrão"
                        class="logoUrl"
                    />
                </ng-template>
            </div>

            <div class="account-info" *ngIf="authService.isLogged()">
                <div class="account-details">
                    <div class="info-row" *ngIf="accountName && accountName !== 'Carregando...'">
                        <span class="info-label">Acesso:</span>
                        <span class="info-value" [title]="accountName">{{ accountName }}</span>
                    </div>
                    <div class="info-row" *ngIf="accountType && accountType !== 'N/A'">
                        <span class="info-label">Conta:</span>
                        <span class="info-value">{{ accountType }}</span>
                    </div>
                    <div class="info-row" *ngIf="!accountName || accountName === 'Carregando...' || !accountType || accountType === 'N/A'">
                        <span class="info-label">Carregando informações...</span>
                    </div>
                </div>
            </div>

            <mat-nav-list  class="nav" role="navigation">

                <mat-list-item class="mt-4"  userRole permission="{{accessControl.ROLE_PERFIL_READ}}" routerLink="/profile" [routerLinkActive]="['is-active']"(click)="handleRedirectTo('profile')">
                    <mat-icon mat-list-icon style="font-size: 1.4rem; margin-right: -8px;">account_circle</mat-icon>
                    <span mat-line style="font-size: 15px;">Perfil</span>
                </mat-list-item>

                <mat-list-item
                    *ngIf="!isMgaAccount"
                    userRole permission="{{accessControl.ROLE_DASHBOARD_READ}}"
                    class="second-item"
                    routerLink="/dashboard-inicial"
                    #dashboardActive="routerLinkActive"
                    [routerLinkActive]="['is-active']">
                    <span mat-list-icon style="font-size: 1.4rem; margin-right: -8px;" class="material-icons">
                        {{ dashboardActive.isActive ? 'dashboard_customize' : 'dashboard' }}
                    </span>
                    <span mat-line style="font-size: 15px;">Painel Geral</span>
                </mat-list-item>

                <mat-accordion userRole permission="{{accessControl.ROLE_REGISTER_READ}}">
                    <mat-expansion-panel hideToggle #cadastroPanel="matExpansionPanel"
                        [expanded]="isCadastroActive()">
                        <mat-expansion-panel-header
                            [ngClass]="{'is-active': isCadastroPanelActive()}">
                            <mat-panel-title class="panel-title-custom" style="padding: 3px 0 !important;">
                                <div class="title-icons-wrapper">
                                    <span mat-list-icon style="font-size: 1.3rem; margin-left: 2px;" class="material-icons">app_registration</span>
                                    <span mat-line style="font-size: 14px;">Cadastro</span>
                                </div>
                                <span class="material-icons menu-arrow" [class.rotated]="cadastroPanel.expanded">expand_more</span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>

                        <mat-list-item
                            *ngIf="!this.isAccountConorMaster"
                            userRole permission="{{accessControl.ROLE_USERS_READ}}"
                            routerLink="/users-management"
                            #usersActive="routerLinkActive"
                            [routerLinkActive]="['sub-menu-active']">
                            <span mat-list-icon style="font-size: 1.4rem; margin-right: -8px;" class="material-icons">group</span>
                            <span mat-line style="font-size: 15px;">Usuários</span>
                        </mat-list-item>

                        <mat-list-item
                            userRole permission="{{accessControl.ROLE_CUSTOMERS_READ}}"
                            routerLink="/customers"
                            #customersActive="routerLinkActive"
                            [routerLinkActive]="['sub-menu-active']">
                            <mat-icon mat-list-icon style="font-size: 1.4rem; margin-right: -8px;">person</mat-icon>
                            <span mat-line style="font-size: 15px;">Clientes</span>
                        </mat-list-item>

                        <mat-list-item
                            *ngIf="isSimplificado"
                            userRole permission="{{accessControl.ROLE_PRODUCTS_READ}}"
                            routerLink="/products"
                            [routerLinkActive]="['sub-menu-active']">
                            <span mat-list-icon style="font-size: 1.4rem; margin-right: -8px;" class="material-icons"> shopping_bag </span>
                            <span mat-line style="font-size: 15px;">Produtos</span>
                        </mat-list-item>

                        <mat-list-item
                            userRole permission="{{accessControl.ROLE_VEHICLES_READ}}"
                            routerLink="/vehicles"
                            #vehiclesActive="routerLinkActive"
                            [routerLinkActive]="isVehiclesActive() ? ['sub-menu-active'] : []"
                            [routerLinkActiveOptions]="{ exact: false }">
                            <span mat-list-icon style="font-size: 1.4rem; margin-right: -8px;" class="material-icons">directions_car</span>
                            <span mat-line style="font-size: 15px;">Veículos</span>
                        </mat-list-item>

                        <mat-list-item
                            *ngIf="isDefaultAccount"
                            userRole permission="{{accessControl.ROLE_VEHICLES_READ}}"
                            routerLink="/vehicles/seguros"
                            #vehiclesWithProductActive="routerLinkActive"
                            [routerLinkActive]="['sub-menu-active']">
                            <span mat-list-icon style="font-size: 1.4rem; margin-right: -8px;" class="material-icons">shield</span>
                            <span mat-line style="font-size: 15px;">Seguros</span>
                        </mat-list-item>

                        <mat-list-item
                            *ngIf="!isMgaAccount && !isSimplificado"
                            userRole permission="{{accessControl.ROLE_TECHNICIANS_READ}}"
                            routerLink="/tecnicos"
                            #techniciansActive="routerLinkActive"
                            [routerLinkActive]="['sub-menu-active']">
                            <span mat-list-icon style="font-size: 1.4rem; margin-right: -8px;" class="material-icons">manage_accounts</span>
                            <span mat-line style="font-size: 15px;">Técnicos</span>
                        </mat-list-item>
                    </mat-expansion-panel>
                </mat-accordion>

                <mat-accordion userRole permission="{{accessControl.ROLE_DESK_READ}}" *ngIf="this.isDefaultAccount || this.isMgaAccount">
                    <mat-expansion-panel hideToggle #escritorioPanel="matExpansionPanel"
                        [expanded]="isEscritorioActive()">
                        <mat-expansion-panel-header
                            [ngClass]="{'is-active': isEscritorioPanelActive()}">
                            <mat-panel-title class="panel-title-custom" style="padding: 3px 0 !important;">
                                <div class="title-icons-wrapper">
                                    <span mat-list-icon style="font-size: 1.3rem; margin-left: 2px;" class="material-icons">business</span>
                                    <span mat-line style="font-size: 14px;">Escritório</span>
                                </div>
                                <span class="material-icons menu-arrow" [class.rotated]="escritorioPanel.expanded">expand_more</span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>

                        <mat-list-item
                            userRole permission="{{accessControl.ROLE_SYSTEM_DOCS_READ}}"
                            routerLink="/documentos"
                            #documentsActive="routerLinkActive"
                            [routerLinkActive]="['sub-menu-active']">
                            <span mat-list-icon style="font-size: 1.4rem; margin-right: -8px;" class="material-icons">description</span>
                            <span mat-line style="font-size: 15px;">Meus Documentos</span>
                        </mat-list-item>

                        <!-- Documento interno, exclusivo do acesso owner/master -->
                        <!-- Apólices e Contratos próprios não existem no modo simplificado,
                             mas as contas anteriores seguem usando: só some para as simplificadas. -->
                        <mat-list-item
                            *ngIf="!isSimplificado"
                            userRole permission="{{accessControl.ROLE_POLICIES_READ}}"
                            routerLink="/apolices"
                            #policiesActive="routerLinkActive"
                            [routerLinkActive]="['sub-menu-active']">
                            <span mat-list-icon style="font-size: 1.4rem; margin-right: -8px;" class="material-icons">security</span>
                            <span mat-line style="font-size: 15px;">Minhas Apólices</span>
                        </mat-list-item>

                        <mat-list-item
                            *ngIf="!isSimplificado"
                            userRole permission="{{accessControl.ROLE_CONTRACTS_READ}}"
                            routerLink="/contracts"
                            #contractsActive="routerLinkActive"
                            [routerLinkActive]="['sub-menu-active']">
                            <span mat-list-icon style="font-size: 1.4rem; margin-right: -8px;" class="material-icons">assignment</span>
                            <span mat-line style="font-size: 15px;">Meus Contratos</span>
                        </mat-list-item>

                        <mat-list-item
                            *ngIf="canAccessMirrorPolicies"
                            routerLink="/mirror-policies"
                            #mirrorPoliciesActive="routerLinkActive"
                            [routerLinkActive]="['sub-menu-active']">
                            <span mat-list-icon style="font-size: 1.4rem; margin-right: -8px;" class="material-icons">content_copy</span>
                            <span mat-line style="font-size: 15px;">Propostas de Seguro</span>
                        </mat-list-item>
                    </mat-expansion-panel>
                </mat-accordion>

                <!-- Integrações Seguradora: o que vem da OON, com apólice e coberturas próprias -->
                <mat-accordion *ngIf="isOonEnabled">
                    <mat-expansion-panel hideToggle #seguradoraPanel="matExpansionPanel"
                        [expanded]="isSeguradoraActive()">
                        <mat-expansion-panel-header
                            [ngClass]="{'is-active': isSeguradoraActive()}">
                            <mat-panel-title class="panel-title-custom" style="padding: 3px 0 !important;">
                                <div class="title-icons-wrapper">
                                    <span mat-list-icon style="font-size: 1.3rem; margin-left: 2px;" class="material-icons">handshake</span>
                                    <span mat-line style="font-size: 14px;">Integrações Seguradora</span>
                                </div>
                                <span class="material-icons menu-arrow" [class.rotated]="seguradoraPanel.expanded">expand_more</span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>

                        <mat-list-item
                            routerLink="/oon-policies"
                            #oonPoliciesActive="routerLinkActive"
                            [routerLinkActive]="['sub-menu-active']">
                            <span mat-list-icon style="font-size: 1.4rem; margin-right: -8px;" class="material-icons">verified_user</span>
                            <span mat-line style="font-size: 15px;">Apólices</span>
                        </mat-list-item>

                        <mat-list-item
                            routerLink="/oon-sinisters"
                            #oonSinistersActive="routerLinkActive"
                            [routerLinkActive]="['sub-menu-active']">
                            <span mat-list-icon style="font-size: 1.4rem; margin-right: -8px;" class="material-icons">report_problem</span>
                            <span mat-line style="font-size: 15px;">Sinistros</span>
                        </mat-list-item>
                    </mat-expansion-panel>
                </mat-accordion>

                <mat-accordion *ngIf="!isMgaAccount && !isSimplificado" userRole permission="{{accessControl.ROLE_OPERATIONAL_READ}}">
                    <mat-expansion-panel hideToggle #operacionalPanel="matExpansionPanel"
                        [expanded]="isOperacionalActive()">
                        <mat-expansion-panel-header
                            [ngClass]="{'is-active': equipmentChipActive.isActive}">
                            <mat-panel-title class="panel-title-custom" style="padding: 3px 0 !important;">
                                <div class="title-icons-wrapper">
                                    <span mat-list-icon style="font-size: 1.3rem; margin-left: 2px;" class="material-icons">engineering</span>
                                    <span mat-line style="font-size: 14px;">Operacional</span>
                                </div>
                                <span class="material-icons menu-arrow" [class.rotated]="operacionalPanel.expanded">expand_more</span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>

                        <mat-list-item
                            userRole permission="{{accessControl.ROLE_TRACKERS_READ}}"
                            routerLink="/devices/equipment-chip"
                            #equipmentChipActive="routerLinkActive"
                            [routerLinkActive]="['sub-menu-active']">
                            <span mat-list-icon style="font-size: 1.4rem; margin-right: -8px;" class="material-icons">devices</span>
                            <span mat-line style="font-size: 15px;">Dispositivos e Chips</span>
                        </mat-list-item>
                    </mat-expansion-panel>
                </mat-accordion>

                <mat-accordion *ngIf="!isMgaAccount && !isSimplificado" userRole permission="{{accessControl.ROLE_MONITORING_READ}}">
                    <mat-expansion-panel hideToggle #monitoramentoPanel="matExpansionPanel"
                        [expanded]="isMonitoramentoActive()">
                        <mat-expansion-panel-header
                            [ngClass]="{'is-active': mapActive.isActive || 
                            reportsActive.isActive || notificationsActive.isActive || notificationsDashboardActive.isActive}">
                            <mat-panel-title class="panel-title-custom" style="padding: 3px 0 !important;">
                                <div class="title-icons-wrapper">
                                    <span mat-list-icon style="font-size: 1.3rem; margin-left: 2px;"  class="material-icons">monitor</span>
                                    <span mat-line style="font-size: 14px;">Monitoramento</span>
                                </div>
                                <span class="material-icons menu-arrow" [class.rotated]="monitoramentoPanel.expanded">expand_more</span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>

                        <mat-list-item
                                routerLink="/monitoramento"
                                #mapActive="routerLinkActive"
                                userRole permission="{{accessControl.ROLE_MAP_READ}}"
                                [routerLinkActive]="['sub-menu-active']"
                                [routerLinkActiveOptions]="{ exact: true }">
                            <span mat-list-icon style="font-size: 1.4rem; margin-right: -8px;"  class="material-icons"> map </span>
                            <span mat-line style="font-size: 15px;"> Mapa </span>
                        </mat-list-item>

                        <mat-list-item
                                routerLink="/monitoramento/relatorios"
                                #reportsActive="routerLinkActive"
                                userRole permission="{{accessControl.ROLE_MONITORING_REPORTS_READ}}"
                                [routerLinkActive]="['sub-menu-active']">
                            <span mat-list-icon style="font-size: 1.4rem; margin-right: -8px;"  class="material-icons"> assessment </span>
                            <span mat-line style="font-size: 15px;"> Relatórios </span>
                        </mat-list-item>

                        <mat-list-item
                                routerLink="/notificacoes"
                                #notificationsActive="routerLinkActive"
                                userRole permission="{{accessControl.ROLE_NOTIFICATIONS_READ}}"
                                [routerLinkActive]="[]"
                                [routerLinkActiveOptions]="{ exact: false }"
                                [ngClass]="{'sub-menu-active': notificationsActive.isActive && !notificationsEventsActive.isActive}"
                                >
                            <span mat-list-icon style="font-size: 1.4rem; margin-right: -8px;"  class="material-icons"> notifications </span>
                            <span mat-line style="font-size: 15px;"> Notificações </span>
                        </mat-list-item>

                        <mat-list-item
                                routerLink="/notificacoes/eventos"
                                #notificationsEventsActive="routerLinkActive"
                                userRole permission="{{accessControl.ROLE_NOTIFICATIONS_MANAGE}}"
                                [routerLinkActive]="['sub-menu-active']">
                            <span mat-list-icon style="font-size: 1.4rem; margin-right: -8px;"  class="material-icons"> event </span>
                            <span mat-line style="font-size: 15px;"> Eventos </span>
                        </mat-list-item>

                        <mat-list-item
                                routerLink="/alertas/dashboard"
                                #notificationsDashboardActive="routerLinkActive"
                                userRole permission="{{accessControl.ROLE_DASHBOARD_NOTIFICATIONS_READ}}"
                                [routerLinkActive]="['sub-menu-active']">
                            <span mat-list-icon style="font-size: 1.4rem; margin-right: -8px;"  class="material-icons"> analytics </span>
                            <span mat-line style="font-size: 15px;">Central de Alertas</span>
                        </mat-list-item>
                    </mat-expansion-panel>
                </mat-accordion>

                <mat-accordion *ngIf="!isMgaAccount && !isSimplificado" userRole permission="{{accessControl.ROLE_INSTALLATION_READ}}">
                    <mat-expansion-panel hideToggle #instalacaoPanel="matExpansionPanel"
                        [expanded]="isInstalacaoActive()">
                        <mat-expansion-panel-header
                            [ngClass]="{'is-active': OSActive.isActive}">
                            <mat-panel-title class="panel-title-custom" style="padding: 3px 0 !important;">
                                <div class="title-icons-wrapper">
                                    <span mat-list-icon style="font-size: 1.3rem; margin-left: 2px;" class="material-icons">build</span>
                                    <span mat-line style="font-size: 14px;">Instalação</span>
                                </div>
                                <span class="material-icons menu-arrow" [class.rotated]="instalacaoPanel.expanded">expand_more</span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>

                        <mat-list-item
                            userRole permission="{{accessControl.ROLE_SERVICE_ORDER_READ}}"
                            routerLink="/ordem-servico"
                            #OSActive="routerLinkActive"
                            [routerLinkActive]="['sub-menu-active']">
                            <span mat-list-icon style="font-size: 1.4rem; margin-right: -8px;" class="material-icons">description</span>
                            <span mat-line style="font-size: 15px;">Ordem de serviço</span>
                        </mat-list-item>

                        <mat-list-item
                            routerLink="/relatorios"
                            userRole permission="{{accessControl.ROLE_OPERATIONAL_REPORTS_READ}}"
                            #reports="routerLinkActive" 
                            [routerLinkActive]="['sub-menu-active']">
                                <span mat-list-icon style="font-size: 1.4rem; margin-right: -8px;" class="material-icons"> bar_chart </span>
                                <span mat-line style="font-size: 15px;"> Relatórios </span>
                        </mat-list-item>
                    </mat-expansion-panel>
                </mat-accordion>

                <mat-accordion
                    *ngIf="this.isDefaultAccount && !isSimplificado"
                    userRole permission="{{accessControl.ROLE_FINANCIAL_MENU_READ}}">
                    <mat-expansion-panel hideToggle #financeiroPanel="matExpansionPanel"
                        [expanded]="isFinanceiroActive()">
                    <mat-expansion-panel-header
                        [ngClass]="{'is-active': chargesActive.isActive ||
                        statementActive.isActive ||
                        dunningsActive.isActive || productsActive.isActive}">

                        <mat-panel-title class="panel-title-custom" style="padding: 3px 0 !important;">
                            <div class="title-icons-wrapper">
                                <span mat-list-icon style="font-size: 1.3rem; margin-left: 2px;"  class="material-icons">attach_money</span>
                                <span mat-line style="font-size: 14px;">Financeiro</span>
                            </div>
                            <span class="material-icons menu-arrow" [class.rotated]="financeiroPanel.expanded">expand_more</span>
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                        <mat-list-item
                            userRole permission="{{accessControl.ROLE_PANEL_READ}}"
                            routerLink="/dashboard"
                            *ngIf="this.isDefaultAccount"
                            [routerLinkActive]="['is-active']">

                            <span mat-list-icon style="font-size: 1.4rem; margin-right: -8px;"  class="material-icons">dashboard</span>
                            <span mat-line style="font-size: 15px;">Minha Central</span>
                        </mat-list-item>

                        <mat-list-item
                        userRole permission="{{accessControl.ROLE_CHARGES_READ}}"
                        routerLink="/charges"
                        [routerLinkActive]="['sub-menu-active']" #chargesActive="routerLinkActive">
                            <span mat-list-icon style="font-size: 1.3rem; margin-right: -8px;"  class="material-icons">price_check</span>
                            <span mat-line style="font-size: 14px;">Cobranças</span>
                        </mat-list-item>

                        <mat-list-item
                            userRole permission="{{accessControl.ROLE_EXTRACT_READ}}"
                            #statementActive="routerLinkActive" routerLink="/statement" [routerLinkActive]="['sub-menu-active']"
                        >
                            <span mat-list-icon style="font-size: 1.4rem; margin-right: -8px;"  class="material-icons">
                                currency_exchange
                                </span>
                            <span mat-line style="font-size: 15px;">Extrato</span>
                        </mat-list-item>

                        <mat-list-item
                        accountBreakpointVersion menuCheck=true
                        userRole permission="{{accessControl.ROLE_PRODUCTS_READ}}"
                        #productsActive="routerLinkActive"
                        routerLink="/products"
                        [routerLinkActive]="['sub-menu-active']"
                        >
                            <span mat-list-icon style="font-size: 1.4rem; margin-right: -8px;"  class="material-icons"> shopping_bag </span>
                            <span mat-line style="font-size: 15px;">Produtos</span>
                        </mat-list-item>

                        <mat-list-item
                        userRole permission="{{accessControl.ROLE_NEGATIVES_READ}}"
                        #dunningsActive="routerLinkActive"
                        routerLink="/dunnings"
                        [routerLinkActive]="['sub-menu-active']"
                        >
                            <span mat-list-icon style="font-size: 1.4rem; margin-right: -8px;" class="material-icons-round"> do_not_disturb_on </span>
                            <span mat-line style="font-size: 15px;">Negativações</span>
                        </mat-list-item>
                    </mat-expansion-panel>
                </mat-accordion>

                <mat-list-item (click)="handleLogout()" class="last-item" >
                    <mat-icon mat-list-icon style="font-size: 1.4rem; margin-right: -8px;" class="material-icons-round">logout</mat-icon>
                    <span mat-line style="font-size: 15px;">Sair</span>
                </mat-list-item>

            </mat-nav-list>

        </div>



    </mat-drawer>

    <mat-drawer-content [ngClass]="{'desktop-content': !isPhone,   'phone-content' : isPhone}" >
        <ng-content></ng-content>

    </mat-drawer-content>
</mat-drawer-container>